import _ from 'lodash';
import React, { Component } from 'react';

import { Menu, Icon } from 'semantic-grab-ui/src';
import './LocalizedMenu.scss';

type MenuTab = {
  label?: React.ReactNode;
};

type Props = {
  allowedTabs?: Record<string, MenuTab>;
  tabs?: string[];
  contents?: Record<string, React.ReactNode>;
  icons?: Record<string, React.ReactNode>;
  handleClickAdd?: () => void;
  handleTabClick?: (tab: string) => void;
  showAddTab?: boolean;
  selectedTab?: string;
};

type State = {
  selectedTab?: string;
};

const getAllowedTab = (
  allowedTabs: Record<string, MenuTab>,
  tab: string,
): MenuTab | undefined => {
  if (allowedTabs[tab]) {
    return allowedTabs[tab];
  }

  const matchingTab = _.findKey(
    allowedTabs,
    (_menuTab, allowedTab) => allowedTab.toLowerCase() === tab.toLowerCase(),
  );

  return matchingTab ? allowedTabs[matchingTab] : undefined;
};

export default class TabbedMenu extends Component<Props, State> {
  static defaultProps = {
    allowedTabs: {},
    contents: {},
    icons: {},
    tabs: [],
    showAddTab: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedTab: (props.tabs || [])[0],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { selectedTab } = this.state;
    const tabs = nextProps.tabs || [];

    if (selectedTab && _.includes(tabs, selectedTab)) {
      return;
    }

    this.setState({
      selectedTab: tabs[0],
    });
  }

  getDefaultSelectedTab(props: Props): string | undefined {
    return props.selectedTab ? props.selectedTab : (props.tabs || [])[0];
  }

  isActive(tab: string): boolean {
    return this.state.selectedTab === tab;
  }

  handleMenuItemChange = (_event: React.SyntheticEvent, data: { name: string }) => {
    const selectedTab = data.name;
    if (this.props.handleTabClick) {
      this.props.handleTabClick(selectedTab);
    }
    this.setState({ selectedTab });
  };

  renderMenuItem(tab: string) {
    const { allowedTabs = {}, icons = {} } = this.props;
    const menuTab = getAllowedTab(allowedTabs, tab);
    const icon = _.get(icons, tab);

    if (menuTab) {
      return (
        <Menu.Item
          className="menu-item"
          id={`menu-item-${tab}`}
          key={tab}
          name={tab}
          active={this.isActive(tab)}
          onClick={this.handleMenuItemChange}
        >
          {menuTab.label || 'Default'}
          {icon && (
            <div className="menu-icon">
              {icon}
            </div>
          )}
        </Menu.Item>
      );
    }
    return (
      <span key={tab}>{tab} is invalid</span>
    );
  }

  renderContents() {
    const { tabs = [], contents = {} } = this.props;
    const { selectedTab } = this.state;

    // When the content is decorated with `formComponent` it will trigger the
    // render every time we change language, so keep all contents mounted.
    return _.map(tabs, (tab) => {
      const id = `menu-content-${tab}`;
      const className = `menu-content ${selectedTab === tab ? 'active' : ''}`;
      return (
        <div id={id} key={tab} className={className}>
          {contents[tab]}
        </div>
      );
    });
  }

  renderMenu() {
    return (
      <Menu pointing secondary>
        {_.map(this.props.tabs || [], tab => this.renderMenuItem(tab))}
        {this.props.showAddTab && (
          <Menu.Item
            className="menu-item"
            onClick={this.props.handleClickAdd}
          >
            <Icon name="plus" className="menu-icon" />
          </Menu.Item>
        )}
      </Menu>
    );
  }

  render() {
    return (
      <div className="localized-menu">
        {this.renderMenu()}
        {this.renderContents()}
      </div>
    );
  }
}
